// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Oo-z","selected":"Po-z"};